<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['data', 'options'],
  computed: {
    
    // デバイス毎のユーザー利用数
    deviceAccessCounts () {
      return this.$store.state.log.deviceAccessCounts
    }
  },
  watch : {
    data : function(val) {
      this.renderChart(this.data, this.options)
    },
    options : function(val) {
      this.renderChart(this.data, this.options)
    },
    deviceAccessCounts : function() {
      this.renderChart({
        labels: this.deviceAccessCounts.date_range,
        datasets: [
          {
            borderColor: '#009CE1',
            borderWidth: 1.5,
            backgroundColor: 'rgba(0,156,225,0.05)',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#009CE1',
            data: this.deviceAccessCounts.access_counts
          }
        ]
      },{
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            stacked: true,
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: "#999"
            }
          }],
          yAxes: [{
            ticks: {
              max: 50,
              fontColor: "#999"
            }
          }]
        },
        maintainAspectRatio: false,
        spanGaps: true,
        elements: {
          line: {
            tension: 0
          }
        }
      })
    }
  }
}
</script>